/**
 * Узел Grouping — элемент с вкладкой, пунктирной обводкой и иконкой в углу.
 */
import ElementNodeTypeBase from '../ElementNodeTypeBase';
import {getGroupingPath, resolveGroupingTabBox} from '@core_x6/lib';
import {ARCHIMATE_PICTO_ICON_CORNER, MIN_GROUP_ELEMENT_HEIGHT} from '../../modelerX6/constants';
import {textAlignToLabelAttrs} from '../textAlignUtil';
import {OTHER_GROUPING} from '../../metamodel/Concept';

export default class GroupingNodeType extends ElementNodeTypeBase {
	static get typeName() {
		return OTHER_GROUPING;
	}

	get shapeId() {
		return 'archimate:grouping';
	}

	get defaultSize() {
		return {width: 120, height: MIN_GROUP_ELEMENT_HEIGHT};
	}

	buildNodeConfig(pathMap, options = {}) {
		const {id, x = 0, y = 0, width, height, label, fillColor, lineColor, textAlign} = options;
		const align = textAlignToLabelAttrs(textAlign, {
			defaultHorizontal: 'left',
			defaultVertical: 'top',
			reserveForIcon: true,
		});
		const w = width ?? this.defaultSize.width;
		const h = height ?? this.defaultSize.height;
		const iconRef = this.iconRef;
		if (!iconRef) {
			throw new Error(`Unsupported element type: ${this.constructor.typeName}`);
		}
		const iconBoxW = Math.round(0.22 * w);
		const iconBoxH = Math.round(0.45 * h);
		const iconPath = pathMap.getScaledPath(iconRef, {
			xScaleFactor: 1,
			yScaleFactor: 1,
			containerWidth: iconBoxW,
			containerHeight: iconBoxH,
			position: {mx: 0, my: 0},
		});
		const fillColorFinal = this.getDefaultFillColor(fillColor);
		const lineColorFinal = this.getDefaultLineColor(lineColor);
		const tabBox = resolveGroupingTabBox({
			width: w,
			height: h,
			label: label ?? '',
			textVerticalAnchor: align.textVerticalAnchor,
			reserveForIcon: true,
		});
		const groupingPath = getGroupingPath({width: w, height: h}, tabBox);
		const nodeAttrs = {
			body: {
				d: groupingPath,
				fill: fillColorFinal,
				stroke: lineColorFinal,
				strokeWidth: 1,
				strokeDasharray: '5 3',
			},
			// Как у DefaultElementNodeType: заливка/обводка иконки = слой (не жёсткий #000, иначе новый PICTO выглядит сплошным чёрным).
			icon: {
				d: iconPath,
				fill: fillColorFinal,
				stroke: lineColorFinal,
				strokeWidth: 0.8,
				...ARCHIMATE_PICTO_ICON_CORNER,
			},
			label: {
				text: label ?? '',
				...align,
				// Под иконку справа — refWidth 0.65 в register; -40 в textWrap — запас вправо.
				textWrap: {width: -40, height: '100%', ellipsis: true, breakWord: true},
			},
		};
		return {
			id,
			x,
			y,
			width: w,
			height: h,
			shape: this.shapeId,
			attrs: nodeAttrs,
			data: {iconRef},
		};
	}
}
